import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { } from '@angular/common/http';
// import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '../../Shared/Components/modal/modal.component';
declare var $: any;



@Component({
  selector: 'app-offering',
  templateUrl: './offering.component.html',
  styleUrls: ['./offering.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OfferingComponent implements OnInit {
  // modalRef!: MDBModalRef;
  public dialogRef !: MatDialogRef<ModalComponent>
  ASDCoreHeader!: string;
  ASDIndustryHeader!: string;

  offeringHeader = "Our Offerings";

  constructor(
    // private _http: HttpClientModule,
    // private modalService: MDBModalService
    private dialog: MatDialog

  ) { }

  ngOnInit(): void {
    this.getTextValues();
    this.btnStartClick()
  }

  btnStartClick() {
    $('#core-tab-md').tab('show');

  }


  getTextValues() {
    this.ASDCoreHeader = "ASD CORE OFFERINGS FOR SAP APPLICATIONS";
    this.ASDIndustryHeader = "INDUSTRY OFFERINGS";
  }

  getElementDetails(elementId: string) {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: false,
      autoFocus: false,
      restoreFocus: false,
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '90vh',
      data: {
        selectedoffering: elementId
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('modal-open');
    });
  }

}
